const DM_ARG_PREFIX = 'dm_'

// Any ?dm_<name>=<value> on this app is forwarded to the DM iframe as ?<name>=<value>
export const getDmArgsFromUrl = (urlParams: URLSearchParams): Record<string, string> =>
  Object.fromEntries(
    [...urlParams]
      .filter(([key]) => key.startsWith(DM_ARG_PREFIX) && key.length > DM_ARG_PREFIX.length)
      .map(([key, value]) => [key.slice(DM_ARG_PREFIX.length), value])
  )
